import Image from 'next/image';
import React from 'react';

// TODO: Get this type from VM once its added
export type VehiclePreviewInfo = {
  vehicleId: number;
  name: string;
  image: string;
  expandedImage: string;
};

export interface VehiclePreviewProps {
  vehiclePreviewInfo: VehiclePreviewInfo;
  isExpanded?: boolean;
}

const VehiclePreview: React.FC<VehiclePreviewProps> = ({
  vehiclePreviewInfo: { vehicleId, name, image, expandedImage },
  isExpanded = false,
}) => {
  return (
    <div
      id={`${vehicleId}-vehicle-thumbnail`}
      className={`flex flex-col ${isExpanded ? 'space-y-2 justify-center' : ''}`}
    >
      <Image
        src={isExpanded ? expandedImage : image}
        alt="Tata Ace"
        width={isExpanded ? 82 : 54}
        height={isExpanded ? 112 : 54}
      />

      {isExpanded && (
        <div id={`${vehicleId}-name`} className={`font-bold block text-4xl`}>
          {name}
        </div>
      )}
    </div>
  );
};

export default VehiclePreview;
